/**
 * Ключ из ссылки переживает неудачную попытку.
 *
 * Фрагмент адреса стирается сразу, до всякой сети, иначе перезагрузка спросила
 * бы про восстановление второй раз. Но между «забрали ключ» и «спросили
 * сервер» помещается и офлайн, и 429, и просто закрытая вкладка — а ключ к
 * этому моменту из адреса уже вырезан. Без этой записи ребёнку пришлось бы
 * просить родителей переслать сообщение заново.
 */

const KEY = 'multiplier.restoreKey'

/** Неделя: дольше висеть незакрытому вопросу незачем. */
export const RESTORE_KEY_TTL_MS = 7 * 24 * 60 * 60 * 1000

export function keepRestoreKey(code: string, at: number): void {
  try {
    localStorage.setItem(KEY, JSON.stringify({ code, at }))
  } catch {
    /* приватный режим — ключ просто не переживёт перезагрузку */
  }
}

export function forgetRestoreKey(): void {
  try {
    localStorage.removeItem(KEY)
  } catch {
    /* нечего чистить */
  }
}

/** Незаданный вопрос, если он ещё не протух. */
export function loadRestoreKey(now: number): string {
  try {
    const raw = localStorage.getItem(KEY)
    if (!raw) return ''

    const saved = JSON.parse(raw) as { code?: unknown; at?: unknown }
    const at = typeof saved.at === 'number' ? saved.at : 0
    const code = typeof saved.code === 'string' ? saved.code : ''
    if (!code || now - at > RESTORE_KEY_TTL_MS) {
      forgetRestoreKey()
      return ''
    }

    return code
  } catch {
    forgetRestoreKey()
    return ''
  }
}
